module.exports = __webpack_public_path__ + "static/VictorinoA-f7b5456d38a297ff08f9f637560903bf.gif";